/**
 * This is where AXIOS requests should be put. Then the store uses these services.
 * !!! NO COMPONENT SHOULD STRAIGHT USE API SERVICES, ONLY IN THE ACTION SECTION OF THE STORE MODULE  !!!
 *
 */
import Axios from "axios";

import { apiUrl, appTitle, serializeObjToGetStr } from "../../constants";

const userBaseUrl = `${apiUrl}/users`;
const config = {
  headers: { "Content-Type": "application/json-patch+json" }
};

export const usersApi = {
  getAll: request => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${userBaseUrl}?${query}`);
  },
  save: user => {
    return Axios.post(userBaseUrl, user.data, config);
  },
  delete: id => {
    return Axios.delete(`${userBaseUrl}/${id}`, config);
  },
  getCurrentUser: () => {
    const usrObj = localStorage.getItem("qlm-user");

    if (usrObj) {
      const obj = JSON.parse(usrObj);
      if (obj && obj.unit === appTitle ) {// is it GMH2, GMH3, etc...
        const userId = obj.usr;
        return Axios.get(`${userBaseUrl}/${userId}/true`, config);
      }// the promise bellow handles "no user"
    }
    return new Promise((resolve, reject) => {
      reject("no user");
    });
  },
  getAllAuthlog: request => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${userBaseUrl}/authlog?${query}`);
  },
  getUserNames:  () => {
    return Axios.get(`${userBaseUrl}/usernames`);
  },
  setNewPassword: (payload) => {
    return Axios.post(
      `${userBaseUrl}/setpwd`,
      JSON.stringify({ userId: payload.userId, password: payload.password}),
      config
    );
  },
};
